import React from "react";
import SysEventsList from "../cimponent/SysEventsList"; 

const SysEventsListContainer = ({ pageId }) => (<SysEventsList pageId={ pageId } />)

export default SysEventsListContainer;